import { useQuery } from '@tanstack/react-query';
import { makeRemoteGetVendorEmail } from '../../main/factories/usecases/vendors';

interface UseVendorEmailParams {
  locationId?: string;
  vendorId?: string;
  enabled?: boolean;
}

export const useVendorEmail = ({ locationId, vendorId, enabled = true }: UseVendorEmailParams) => {
  const vendorEmailService = makeRemoteGetVendorEmail();

  return useQuery({
    queryKey: ['vendor-email', locationId, vendorId],
    queryFn: async () => {
      if (!locationId || !vendorId) {
        throw new Error('locationId and vendorId are required');
      }
      const result = await vendorEmailService.get({ locationId, vendorId });
      return result;
    },
    enabled: enabled && !!locationId && !!vendorId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
